import { Pipe, PipeTransform } from '@angular/core';
   import { DatePipe } from '@angular/common';
   
   @Pipe({
     name: 'customDate'
   })
   export class CustomDatePipe extends 
                DatePipe implements PipeTransform {
     transform(value: any, format?: any): any {
        if(format!=null){
            return super.transform(value, format);
        }
       return super.transform(value, "dd-MM-yyyy");
     }
   }